(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cm-roman-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const roots = new Map();
  const threadColours = {White:'#f6f3ec','Light Grey':'#bfc1c2','Dark Grey':'#626368',Black:'#141519','Dark Purple':'#633a82','Baby Blue':'#abd5e8','Baby Pink':'#efb8ce','Hot Pink':'#df368e',Green:'#327c52',Yellow:'#f3ce34',Orange:'#ed762c',Red:'#bb2940',Brown:'#774c38','Dark Blue':'#223a70',Gold:'#bfa064','Glow in the Dark':'#d4e8b8',Cream:'#f1e8d2',Grey:'#8b8e91',Pink:'#e897bc',Blue:'#367bb9',Purple:'#79559c'};
  const garmentColours = {Black:'#28282a',White:'#faf9f5','Military Green':'#646956','Navy Blue':'#263345',Navy:'#263345',Pink:'#f0c7d5',Stone:'#d3c8b3',Grey:'#949697','Black Oversized':'#272729','White Oversized':'#faf9f5'};
  const hoodieImages = {
    'Deep Black':'Black.jpg?v=1755873986', 'Forest Green':'Forest.jpg?v=1755873986', 'Natural Stone':'Stone.jpg?v=1755873986',
    White:'White_7dc2f72f-f950-4e86-a923-d31c515d4e2c.jpg?v=1767802784', 'Oxford Navy':'Navy.jpg?v=1755873986',
    'Blush Pink':'Blush_Pink.jpg?v=1755873986','Dusty Blue':'Stone_Blue.png?v=1755873986','Storm Grey':'Storm_Grey.jpg?v=1755873986',
    Sage:'Sage.jpg?v=1756646729',Burgundy:'Burgundy_1.jpg?v=1756646619',Pink:'cm-roman-variant-hoodie-pink.webp?v=1789647965'
  };
  const cdn='https://cdn.shopify.com/s/files/1/0704/6683/0623/files/';
  const kidsSizeHoodieImages={'Deep Black':'cm-roman-kids-size-hoodie-black.webp?v=1789648429','Oxford Navy':'cm-roman-kids-size-hoodie-navy.jpg?v=1789648450','Forest Green':'cm-roman-kids-size-hoodie-green.jpg?v=1789648477',Pink:'cm-roman-variant-hoodie-pink.webp?v=1789647965'};
  const shirtImage=cdn+'cm-roman-tshirt-blank.png?v=1789638392&width=1000';
  const whiteShirtImage=cdn+'cm-roman-tshirt-white.png?v=1789640193&width=1000';
  const kidsSizeShirtImages={Black:'cm-roman-kids-size-tshirt-black.jpg?v=1789649003',Navy:'cm-roman-kids-size-tshirt-navy.jpg?v=1789648956',Pink:'cm-roman-kids-size-tshirt-pink.jpg?v=1789648972',White:'cm-roman-kids-size-tshirt-white.jpg?v=1789648988'};
  const iconUrls={Heart:cdn+'a_J15r_SCRIBBLE_20HEART_200x.png','Infinity Sign':cdn+'a_JURY_Screenshot_202025-05-16_20104547_200x.png'};
  const sweatshirtImages={'Deep Black':'Deep_Black.webp?v=1768317866','Oxford Navy':'Oxford_Navy.webp?v=1768317866','Storm Grey':'Storm_Grey.webp?v=1768317866','Baby Pink':'cm-roman-variant-sweatshirt-baby-pink.webp?v=1789648021','Dusty Green':'cm-roman-variant-sweatshirt-dusty-green.webp?v=1789648048','Sea Foam':'cm-roman-variant-sweatshirt-seafoam.webp?v=1789648061'};
  const kidsSizeSweatshirtImages={'Deep Black':'cm-roman-kids-size-sweatshirt-black.jpg?v=1789648584','Baby Pink':'cm-roman-kids-size-sweatshirt-baby-pink.jpg?v=1789648603','Dusty Green':'cm-roman-kids-size-sweatshirt-dusty-green.jpg?v=1789648567','Sea Foam':'cm-roman-kids-size-sweatshirt-seafoam.jpg?v=1789648548'};
  const kidsSweatshirtCuffs={'Deep Black':{x:944,y:940,iconY:964,crop:[815,820,265,360]},'Baby Pink':{x:944,y:940,iconY:964,crop:[815,820,265,360]},'Dusty Green':{x:947,y:1010,iconY:1034,crop:[825,855,250,345]},'Sea Foam':{x:915,y:985,iconY:1009,crop:[800,845,250,345]}};
  const kidsImages={Black:cdn+'cm-roman-kids-black.png?v=1789641954&width=1200','Olive Green':cdn+'cm-roman-kids-olive.png?v=1789641975&width=1200',Grey:cdn+'cm-roman-kids-grey.png?v=1789642000&width=1200'};
  const images=new Map();
  const hoodieChest={x:748,y:446,hoopMm:130,edgeAllowanceMm:5,pixelsPerMm:1.2,fontPx:28};
  function loadImage(url) {
    if (!images.has(url)) images.set(url,new Promise((resolve,reject)=>{const img=new Image();img.crossOrigin='anonymous';img.onload=()=>resolve(img);img.onerror=()=>{images.delete(url);reject(new Error('image'));};img.src=url;}));
    return images.get(url);
  }
  function numberToRoman(n) {
    let value='';
    for(const [v,s] of [[1000,'M'],[900,'CM'],[500,'D'],[400,'CD'],[100,'C'],[90,'XC'],[50,'L'],[40,'XL'],[10,'X'],[9,'IX'],[5,'V'],[4,'IV'],[1,'I']]) while(n>=v){value+=s;n-=v;}
    return value;
  }
  function dateToRoman(raw) {
    raw=raw.trim(); if(!raw)return null;
    const iso=raw.match(/^(\d{4})-(\d{2})-(\d{2})$/), local=raw.match(/^(\d{1,2})[/.\-](\d{1,2})[/.\-](\d{2}|\d{4})$/), compact=raw.match(/^(\d{2})(\d{2})(\d{2})$/);
    const match=iso||local||compact;if(!match)throw new Error('date');
    const d=Number(match[iso?3:1]),m=Number(match[2]),year=match[iso?1:3],y=Number(year),calendarYear=year.length===2?2000+y:y;
    const leap=calendarYear%4===0&&(calendarYear%100!==0||calendarYear%400===0),days=[31,leap?29:28,31,30,31,30,31,31,30,31,30,31];
    if(y<1||y>3999||m<1||m>12||d<1||d>days[m-1])throw new Error('date');
    return {roman:[d,m,y].map(numberToRoman).join('·'),display:[String(d).padStart(2,'0'),String(m).padStart(2,'0'),year].join('/')};
  }
  function element(tag,cls,text){const e=document.createElement(tag);if(cls)e.className=cls;if(text)e.textContent=text;return e;}
  function mount(configNode) {
    let config;try{config=JSON.parse(configNode.querySelector('script').textContent);}catch{return;}
    const scope=document.querySelector('.product-section[data-product-id="'+config.productId+'"]:not([data-modal="true"])');
    if(!scope||roots.has(scope))return;
    const gallery=scope.querySelector('.product__photos'),meta=scope.querySelector('.product-single__meta'),form=scope.querySelector('form[action*="/cart/add"]');
    if(!gallery||!meta||!form)return;
    const l=config.labels,isEmbroidered=config.kind!=='tshirt',isKids=config.kind==='kids',isSweatshirt=config.kind==='sweatshirt',controller=new AbortController(),signal=controller.signal;
    let isOpen=false,view='front',zoom=false,renderRevision=0,lastSignature='',timer=0,dateBridge=null,kidsSleeve=null;
    const panel=element('section','cm-roman-panel');panel.hidden=true;panel.id='cm-roman-'+config.productId;
    const toolbar=element('div','cm-roman-toolbar'),heading=element('h2','cm-roman-title',l.title);heading.tabIndex=-1;
    const photos=element('button','cm-roman-text-button',l.photos);photos.type='button';toolbar.append(heading,photos);
    const views=element('div','cm-roman-views');views.setAttribute('role','group');views.setAttribute('aria-label',l.preview);
    const front=element('button','cm-roman-tab',l.front),sleeve=element('button','cm-roman-tab',l.sleeve),zoomButton=element('button','cm-roman-text-button cm-roman-zoom',l.zoom);
    for(const b of [front,sleeve,zoomButton])b.type='button';front.setAttribute('aria-pressed','true');sleeve.setAttribute('aria-pressed','false');zoomButton.setAttribute('aria-pressed','false');
    views.append(front);if(isEmbroidered)views.append(sleeve);views.append(zoomButton);
    const stage=element('div','cm-roman-stage'),canvas=element('canvas','cm-roman-canvas');canvas.width=1200;canvas.height=1200;canvas.setAttribute('role','img');canvas.setAttribute('aria-label',l.garment_alt);
    const stageMessage=element('p','cm-roman-stage-message',l.loading);stage.append(canvas,stageMessage);
    const summary=element('div','cm-roman-summary'),romanLabel=element('span','cm-roman-eyebrow',l.roman_label),roman=element('p','cm-roman-value'),date=element('p','cm-roman-date');
    const status=element('p','cm-roman-status',l.choose_date);status.setAttribute('role','status');status.setAttribute('aria-live','polite');
    const selection=element('p','cm-roman-selection'),note=element('p','cm-roman-note',l.note),oversizedNote=element('p','cm-roman-note',l.oversized_note);oversizedNote.hidden=true;
    const editOptions=element('button','cm-roman-edit',l.edit_options);editOptions.type='button';
    summary.append(romanLabel,roman,date,status,selection,editOptions);panel.append(toolbar,views,stage,summary,oversizedNote,note);gallery.before(panel);
    const column=gallery.closest('.product-single__sticky');
    function properties(){return Array.from(scope.querySelectorAll('[name^="properties["]'));}
    function field(name){return properties().find(e=>e.name.slice(11,-1).trim().toLowerCase()===name.toLowerCase());}
    let syncingSleeve=false;
    const composingSleeves=new WeakSet();
    function normaliseSleeveInitials(input){
      if(!isEmbroidered||!(input instanceof HTMLInputElement)||!/^properties\[\s*sleeve initials\s*\]$/i.test(input.name))return false;
      input.setAttribute('autocapitalize','characters');
      if(composingSleeves.has(input))return false;
      const value=input.value,upper=value.toUpperCase();if(value===upper)return false;
      const start=input.selectionStart,end=input.selectionEnd,direction=input.selectionDirection;
      // Use the native setter so controlled inputs still detect the input event.
      Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value').set.call(input,upper);
      if(start!==null&&end!==null)input.setSelectionRange(value.slice(0,start).toUpperCase().length,value.slice(0,end).toUpperCase().length,direction);
      return true;
    }
    function syncSleeveInitials(){
      if(syncingSleeve)return;
      syncingSleeve=true;
      try{for(const input of properties())if(normaliseSleeveInitials(input)){
        input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));
      }}finally{syncingSleeve=false;}
    }
    // Capture before the existing options app reads typed or pasted initials.
    for(const type of ['input','change'])scope.addEventListener(type,event=>{if(!event.isComposing)normaliseSleeveInitials(event.target);},{capture:true,signal});
    scope.addEventListener('compositionstart',event=>composingSleeves.add(event.target),{capture:true,signal});
    scope.addEventListener('compositionend',event=>{composingSleeves.delete(event.target);syncSleeveInitials();update();},{capture:true,signal});
    form.addEventListener('submit',syncSleeveInitials,{capture:true,signal});
    function enhanceDate(){
      if(isEmbroidered)return;
      const source=field('Enter the Date');
      if(!source||dateBridge?.source===source&&dateBridge.picker.isConnected)return;
      dateBridge?.dispose();
      const picker=element('input',source.className+' cm-roman-date-picker');picker.type='date';picker.id=(source.id||'cm-roman-date-'+config.productId)+'-date';picker.required=source.required;picker.min='0001-01-01';picker.max='3999-12-31';
      if(source.hasAttribute('form'))picker.setAttribute('form',source.getAttribute('form'));
      if(source.hasAttribute('aria-describedby'))picker.setAttribute('aria-describedby',source.getAttribute('aria-describedby'));
      picker.setAttribute('aria-label',l.date_label);
      try{const parsed=dateToRoman(source.value);if(parsed){const [d,m,y]=parsed.display.split('/');picker.value=(y.length===2?'20'+y:y)+'-'+m+'-'+d;}}catch{}
      const label=Array.from(meta.querySelectorAll('label')).find(e=>e.htmlFor===source.id),original={hidden:source.hidden,required:source.required,tabindex:source.getAttribute('tabindex')};
      source.hidden=true;source.required=false;source.tabIndex=-1;source.classList.add('cm-roman-order-date');source.after(picker);if(label)label.htmlFor=picker.id;
      const sync=()=>{let value='';try{value=dateToRoman(picker.value)?.display||'';}catch{}if(source.value!==value){source.value=value;source.dispatchEvent(new Event('input',{bubbles:true}));source.dispatchEvent(new Event('change',{bubbles:true}));}};
      picker.addEventListener('input',sync,{signal});picker.addEventListener('change',sync,{signal});
      dateBridge={source,picker,sync,dispose(){picker.remove();source.hidden=original.hidden;source.required=original.required;if(original.tabindex===null)source.removeAttribute('tabindex');else source.setAttribute('tabindex',original.tabindex);source.classList.remove('cm-roman-order-date');if(label)label.htmlFor=source.id;}};
    }
    function sleeveEnabled(){
      if(isKids)return /^yes$/i.test(scope.querySelector('input[name="Add Sleeve Personalisation"]:checked')?.value||'');
      return !!field('Would you like to add a Sleeve?')?.closest('.cl-po--option')?.querySelector('input[type="checkbox"]:checked');
    }
    function ensureKidsSleeve(){
      if(!isKids)return;
      const anchor=scope.querySelector('.cl-po--options');if(!anchor)return;
      const existing=properties().find(e=>e.name==='properties[Sleeve Initials]'&&!kidsSleeve?.contains(e));
      if(existing){kidsSleeve?.remove();kidsSleeve=null;return;}
      if(!kidsSleeve){
        kidsSleeve=element('div','cm-roman-kids-sleeve');
        const initialsLabel=element('label','cl-po--label',l.sleeve_initials),initials=element('input','cl-po--input');initials.type='text';initials.name='properties[Sleeve Initials]';initials.id='cm-roman-initials-'+config.productId;initials.maxLength=10;initials.setAttribute('form',form.getAttribute('id'));initialsLabel.htmlFor=initials.id;
        const iconsLabel=element('label','cl-po--label',l.icons),icons=element('select','cl-po--input');icons.name='properties[Icons]';icons.id='cm-roman-icon-'+config.productId;icons.setAttribute('form',form.getAttribute('id'));iconsLabel.htmlFor=icons.id;
        for(const [value,label] of [['No Icon',l.no_icon],['Infinity Sign',l.infinity],['Heart',l.heart]]){const option=element('option','',label);option.value=value;icons.append(option);}
        const first=element('div','cm-roman-kids-field'),second=element('div','cm-roman-kids-field');first.append(initialsLabel,initials);second.append(iconsLabel,icons);kidsSleeve.append(first,second);
      }
      if(!kidsSleeve.isConnected)anchor.after(kidsSleeve);
      const enabled=sleeveEnabled();if(kidsSleeve.hidden===enabled)kidsSleeve.hidden=!enabled;
      for(const input of kidsSleeve.querySelectorAll('input,select')){input.disabled=!enabled;if(input.tagName==='INPUT')input.required=enabled;}
    }
    function readState(){
      const colour=Array.from(scope.querySelectorAll('input[type="radio"]:checked,select')).find(e=>/^(hoodie colour|sweatshirt colour|colour|color)$/i.test(e.name))?.value||'';
      const size=Array.from(scope.querySelectorAll('input[type="radio"]:checked,select')).find(e=>/^size$/i.test(e.name))?.value||'';
      const rawDate=isEmbroidered?(scope.querySelector('.cl-po--option input[type="date"]')?.value||field('Date')?.value||''):(field('Enter the Date')?.value||'');
      const thread=field(isEmbroidered?'Embroidery Colours':'Text Colour')?.value||'';
      const hasSleeve=sleeveEnabled();
      let parsed=null,error=false;try{parsed=dateToRoman(rawDate);}catch{error=true;}
      return {colour,size,rawDate,thread,hasSleeve,initials:hasSleeve?(field('Sleeve Initials')?.value||''):'',icon:hasSleeve?(field('Icons')?.value||''):'',parsed,error};
    }
    function show(open,focus=true){
      isOpen=open;panel.hidden=!open;gallery.classList.toggle('cm-roman-photos-hidden',open);column?.classList.toggle('cm-roman-gallery-open',open);
      window.dispatchEvent(new Event('resize'));
      if(open){update(true);if(focus){heading.focus({preventScroll:true});panel.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}}
      else if(focus)photos.blur();
    }
    function changeView(next){view=next;zoom=false;front.setAttribute('aria-pressed',String(view==='front'));sleeve.setAttribute('aria-pressed',String(view==='sleeve'));zoomButton.setAttribute('aria-pressed','false');zoomButton.textContent=l.zoom;update(true);}
    photos.addEventListener('click',()=>show(false),{signal});front.addEventListener('click',()=>changeView('front'),{signal});sleeve.addEventListener('click',()=>changeView('sleeve'),{signal});
    zoomButton.addEventListener('click',()=>{zoom=!zoom;zoomButton.setAttribute('aria-pressed',String(zoom));zoomButton.textContent=zoom?l.zoom_out:l.zoom;update(true);},{signal});
    editOptions.addEventListener('click',()=>{const input=scope.querySelector('input[type="date"]');input?.scrollIntoView({behavior:'smooth',block:'center'});input?.focus({preventScroll:true});},{signal});
    panel.addEventListener('keydown',e=>{if(e.key==='Escape')show(false);},{signal});
    const onChange=event=>{
      if(syncingSleeve)return;
      const target=event.target;
      if(!isOpen&&(event.type==='input'||event.type==='change')&&target instanceof Element&&(target.closest('.cl-po--option')||target.matches('[name^="properties["],.cm-roman-date-picker,[name="Add Sleeve Personalisation"]')))show(true,false);
      update();clearTimeout(timer);timer=setTimeout(()=>{dateBridge?.sync();update();},80);
    };
    scope.addEventListener('input',onChange,{signal});scope.addEventListener('change',onChange,{signal});scope.addEventListener('click',onChange,{signal});document.addEventListener('variant:change',onChange,{signal});
    const observer=new MutationObserver(()=>{if(!scope.isConnected){observer.disconnect();controller.abort();clearTimeout(timer);roots.delete(scope);return;}update();});
    observer.observe(meta,{childList:true,subtree:true,attributes:true,attributeFilter:['value','checked','selected']});
    function drawText(ctx,text,x,y,size,maxWidth,color,embroidered=false){
      if(!text)return;ctx.save();ctx.textAlign='center';ctx.textBaseline='middle';ctx.font='400 '+size+'px "Times New Roman", Times, serif';ctx.fillStyle=color;
      if(embroidered){ctx.shadowColor='rgba(0,0,0,.2)';ctx.shadowBlur=1.2;ctx.shadowOffsetY=1;}
      ctx.fillText(text,x,y,maxWidth);ctx.restore();
    }
    async function render(s){
      const revision=++renderRevision;stageMessage.hidden=false;stageMessage.textContent=l.loading;
      try{
        const kidsSweatshirt=isSweatshirt&&/^Kids\b/i.test(s.size)&&!!kidsSizeSweatshirtImages[s.colour];
        const newSweatshirtColour=isSweatshirt&&(['Baby Pink','Dusty Green','Sea Foam'].includes(s.colour)||kidsSweatshirt);
        const chest=isKids?{x:600,y:s.colour==='Black'?503:420,fontPx:44,maxWidth:300}:isSweatshirt?{...hoodieChest,x:742,y:newSweatshirtColour?375:445}:hoodieChest;
        const cuff=isKids?{x:950,y:1008,iconY:1032,crop:[825,855,250,345]}:kidsSweatshirt?kidsSweatshirtCuffs[s.colour]:newSweatshirtColour?{x:952,y:1010,iconY:1034,crop:[825,855,250,345]}:isSweatshirt?{x:933,y:955,iconY:979,crop:[810,790,260,360]}:{x:923,y:943,iconY:967,crop:[800,750,260,360]};
        const whiteShirt=!isEmbroidered&&/^White(?: Oversized)?$/i.test(s.colour);
        const kidsShirt=!isEmbroidered&&/^Kids\b/i.test(s.size)&&!!kidsSizeShirtImages[s.colour];
        const hoodieImage=config.kind==='hoodie'&&/^Kids\b/i.test(s.size)?kidsSizeHoodieImages[s.colour]||hoodieImages[s.colour]:hoodieImages[s.colour];
        const sweatshirtImage=kidsSweatshirt?kidsSizeSweatshirtImages[s.colour]:sweatshirtImages[s.colour];
        const garment=await loadImage(isKids?kidsImages[s.colour]:isSweatshirt?cdn+(sweatshirtImage||sweatshirtImages['Deep Black'])+'&width=1200':isEmbroidered?cdn+(hoodieImage||hoodieImages['Deep Black'])+'&width=1200':kidsShirt?cdn+kidsSizeShirtImages[s.colour]+'&width=1200':whiteShirt?whiteShirtImage:shirtImage);
        if(revision!==renderRevision)return;
        const off=document.createElement('canvas');off.width=1200;off.height=1200;const ctx=off.getContext('2d');ctx.fillStyle='#fff';ctx.fillRect(0,0,1200,1200);
        if(newSweatshirtColour||kidsShirt){const scale=1040/Math.max(garment.naturalWidth,garment.naturalHeight),width=garment.naturalWidth*scale,height=garment.naturalHeight*scale;ctx.drawImage(garment,(1200-width)/2,(1200-height)/2,width,height);}else if(isEmbroidered||whiteShirt){ctx.drawImage(garment,0,0,1200,1200);}else{
          const tinted=document.createElement('canvas');tinted.width=1200;tinted.height=1200;const tc=tinted.getContext('2d');tc.drawImage(garment,0,0,1200,1200);tc.globalCompositeOperation='multiply';tc.fillStyle=garmentColours[s.colour]||garmentColours.Black;tc.fillRect(0,0,1200,1200);tc.globalCompositeOperation='destination-in';tc.drawImage(garment,0,0,1200,1200);ctx.drawImage(tinted,0,0);
        }
        const textColour=threadColours[s.thread];
        if(s.parsed&&textColour)drawText(ctx,s.parsed.roman,isEmbroidered?chest.x:600,isEmbroidered?chest.y:kidsShirt?365:421,isEmbroidered?chest.fontPx:kidsShirt?42:52,isEmbroidered?(chest.maxWidth||(chest.hoopMm-2*chest.edgeAllowanceMm)*chest.pixelsPerMm):kidsShirt?350:480,textColour,isEmbroidered);
        if(isEmbroidered&&s.hasSleeve&&textColour){
          drawText(ctx,s.initials.replace(/<3/g,'♥'),cuff.x,cuff.y,21,83,textColour,true);
          if(iconUrls[s.icon]){
            try{const icon=await loadImage(iconUrls[s.icon]);if(revision!==renderRevision)return;const ic=document.createElement('canvas');ic.width=icon.naturalWidth;ic.height=icon.naturalHeight;const ix=ic.getContext('2d');ix.drawImage(icon,0,0);const pixels=ix.getImageData(0,0,ic.width,ic.height);for(let n=0;n<pixels.data.length;n+=4){const bright=Math.min(pixels.data[n],pixels.data[n+1],pixels.data[n+2]);pixels.data[n+3]=Math.round(pixels.data[n+3]*(255-bright)/255);}ix.putImageData(pixels,0,0);ix.globalCompositeOperation='source-in';ix.fillStyle=textColour;ix.fillRect(0,0,ic.width,ic.height);const scale=Math.min(58/ic.width,40/ic.height),width=ic.width*scale,height=ic.height*scale;ctx.drawImage(ic,cuff.x-width/2,cuff.iconY-height/2,width,height);}catch{drawText(ctx,s.icon==='Heart'?'♡':'∞',cuff.x,cuff.iconY,24,50,textColour,true);}
          }
        }
        const output=canvas.getContext('2d');output.clearRect(0,0,1200,1200);output.fillStyle='#fff';output.fillRect(0,0,1200,1200);
        if(view==='sleeve'&&isEmbroidered){const width=1200*cuff.crop[2]/cuff.crop[3];output.drawImage(off,...cuff.crop,(1200-width)/2,0,width,1200);}
        else if(zoom){if(isEmbroidered)output.drawImage(off,chest.x-210,chest.y-210,420,420,0,0,1200,1200);else output.drawImage(off,285,230,630,630,0,0,1200,1200);}
        else output.drawImage(off,0,0);
        stageMessage.hidden=true;
        canvas.setAttribute('aria-label',[s.colour,l.garment_alt,s.parsed?.roman,s.thread,view==='sleeve'?s.initials:''].filter(Boolean).join(' — '));
      }catch{if(revision===renderRevision){canvas.getContext('2d').clearRect(0,0,1200,1200);stageMessage.textContent=l.image_error;stageMessage.hidden=false;}}
    }
    function update(force=false){
      enhanceDate();ensureKidsSleeve();syncSleeveInitials();
      const s=readState(),signature=JSON.stringify([s,view,zoom]);if(!force&&signature===lastSignature)return;lastSignature=signature;
      roman.textContent=s.parsed?.roman||'—';date.textContent=s.parsed?.display||'';
      let message=s.error?l.invalid_date:!s.parsed?l.choose_date:!s.thread?(isEmbroidered?l.choose_colour:l.choose_text_colour):'';
      if(view==='sleeve')message=!s.hasSleeve?l.no_sleeve:!s.initials?l.sleeve_empty:message;
      status.textContent=message;status.hidden=!message;status.classList.toggle('cm-roman-error',s.error);
      selection.textContent=[s.colour,s.thread,view==='sleeve'&&s.hasSleeve?s.initials:'',view==='sleeve'&&s.hasSleeve?s.icon:''].filter(Boolean).join(' · ');
      oversizedNote.hidden=!/oversized/i.test(s.colour);
      if(isOpen)void render(s);
    }
    roots.set(scope,{dispose(){controller.abort();observer.disconnect();clearTimeout(timer);dateBridge?.dispose();kidsSleeve?.remove();renderRevision++;panel.remove();gallery.classList.remove('cm-roman-photos-hidden');column?.classList.remove('cm-roman-gallery-open');roots.delete(scope);}});
    update();
  }
  function boot(){document.querySelectorAll('[data-cm-roman-config]').forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:unload',event=>{for(const [scope,instance] of roots)if(event.target.contains(scope))instance.dispose();});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-button__text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.findSubmitButton();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]');
      return submitButton;
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('product-form__submit-button--pulsing');
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('product-form__submit-button--pulsing');
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      // Disable submit button and start pulsing
      this.disableSubmitButton();

      // Get cart state before form submission
      let cartBeforeSubmission;
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        cartBeforeSubmission = await cartResponse.json();
      } catch (error) {
        console.error('Failed to get cart state before submission:', error);
        cartBeforeSubmission = null;
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      };

      const formData = new FormData(this.form);

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData,
          },
          cancelable: true
        })
      );

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise(resolve => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve);
      });

      config.body = formData;

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      });

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent);
      let responseData;

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse();
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);       
          responseData = await response.json();

          if (!response.ok) {
            throw responseData;
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartAfterSubmission = await cartResponse.json();

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            },
          })
        );

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              },
            })
          );
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        });

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent);
        
        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`;
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            },
          })
        );
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton();
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject };
        
        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver;
            reject(new Error('Cart request timeout - no response received from subscriber'));
          }
        }, 30000); // 30 second timeout
        
        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout;
      });
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.resolve(responseData);
        delete this._cartRequestResolver;
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout);
        this._cartRequestResolver.reject(error);
        delete this._cartRequestResolver;
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true; // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter);
    }
  }

  customElements.define('product-form', ProductForm);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super();
      
      // Pull localized error message from data attributes
      this.formId = this.dataset.formId;
      this.defaultErrorMessage = this.dataset.error;
      this.defaultSuccessMessage = this.dataset.success;
      
      // Create abort controller for event cleanup
      this.abortController = new AbortController();
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate();
      this.bindEvents();
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort();
    }

    cacheTemplate() {
      const template = this.querySelector('template');
      if (template) {
        this.template = template.innerHTML;
        this.templateElement = template;
      }
    }

    bindEvents() {
      const { signal } = this.abortController;
      
      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal });
      
      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal });

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal });
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      this.clearMessages();
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      let message = this.defaultSuccessMessage;

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(successMessageEvent.detail.message);
    }

    handleError(e) { 
      if (e.target.form.getAttribute('id') !== this.formId) {
        return;
      }

      const error = e.detail.error;
      let message = this.defaultErrorMessage;
      
      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description;
      } else if (error.message) {
        message = error.message;
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      });

      const eventCancelled = !this.dispatchEvent(errorMessageEvent);

      if (eventCancelled) {
        return;
      }

      this.showMessage(errorMessageEvent.detail.message);
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages();
      this.classList.remove('hide');
      
      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message);
        
        // Insert the error message content
        this.innerHTML = messageContent;
      }
    }

    clearMessages() {
      this.classList.add('hide');

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML;
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kit.popover"] && !Shopify.designMode) return;
  try {
    class KitPopover extends HTMLElement {
    #abortController = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      // Prevent flash of previously-positioned popover
      this.addEventListener(
        'beforetoggle',
        (event) => {
          if (event.newState === 'open') {
            this.style.visibility = 'hidden';
          }
        },
        { signal }
      );

      this.addEventListener(
        'toggle',
        (event) => {
          if (event.newState === 'open') {
            this.#position();
            this.style.visibility = '';
          }
        },
        { signal }
      );

      window.addEventListener(
        'resize',
        () => {
          if (this.matches(':popover-open')) this.#position();
        },
        { signal, passive: true }
      );

      this.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a[href], button:not([popovertarget])')) {
            this.hidePopover();
          }
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.#abortController?.abort();
    }

    #position() {
      const trigger = document.querySelector(`[popovertarget="${this.id}"]`);
      if (!trigger) return;

      const placement = this.getAttribute('placement') || 'bottom-start';
      const isRTL = getComputedStyle(this).direction === 'rtl';
      const gap = Number(this.getAttribute('gap') ?? 4);
      const margin = 4;

      const triggerRect = trigger.getBoundingClientRect();
      const popoverWidth = this.offsetWidth;
      const popoverHeight = this.offsetHeight;

      const [axis, alignment] = placement.split('-');

      let top = axis === 'bottom' ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap;
      let resolvedAxis = axis;

      // Auto-flip vertically if overflowing viewport
      if (axis === 'bottom' && top + popoverHeight > window.innerHeight - margin) {
        top = triggerRect.top - popoverHeight - gap;
        resolvedAxis = 'top';
      } else if (axis === 'top' && top < margin) {
        top = triggerRect.bottom + gap;
        resolvedAxis = 'bottom';
      }

      const alignStart = isRTL ? 'end' : 'start';
      let left;
      if (alignment === 'center') {
        left = triggerRect.left + (triggerRect.width - popoverWidth) / 2;
      } else if (alignment === alignStart) {
        left = triggerRect.left;
      } else {
        left = triggerRect.right - popoverWidth;
      }

      // Clamp horizontally to viewport
      if (left < margin) {
        left = margin;
      } else if (left + popoverWidth > window.innerWidth - margin) {
        left = window.innerWidth - popoverWidth - margin;
      }

      this.style.transformOrigin = resolvedAxis === 'bottom' ? 'top' : 'bottom';

      // Convert to document coordinates so popover scrolls with page
      this.style.top = `${Math.round(top + window.scrollY)}px`;
      this.style.left = `${Math.round(left + window.scrollX)}px`;
    }
  }

  customElements.define('kit-popover', KitPopover);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }
    
    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.trapFocus(this);
    }

    close() {
      this.setAttribute('open', 'false');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map();
    // Track which groups have been prefetched
    static prefetchedGroups = new Set();

    constructor() {
      super();
      this.trigger = null;
      this.template = null;
      this.overlay = null;
      this.closeBtn = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.group = this.dataset.group;
      this.groupItems = [];
      this.currentIndex = 0;

      // Register this instance
      if (this.group) { 
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, []);
        }
        OverlayLightbox.registry.get(this.group).push(this);
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger');
      this.template = this.querySelector('.overlay-lightbox__template');
      this.init();
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openLightbox();
        });
      }


      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox();
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateToPrevious();
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateToNext();
          }
        }
      });
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay();
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open');
      document.body.style.overflow = 'hidden';

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems();

        // Prefetch images for the group
        this.prefetchGroupImages();

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item');
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item');
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found');
        return;
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay');
      
      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template');
        return;
      }
      
      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close');
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev');
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next');

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.closeLightbox();
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToPrevious();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigateToNext();
        });
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox();
          }
        });
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay);
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open');
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item');
        
        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay);
          this.overlay = null;
          this.closeBtn = null;
          this.prevBtn = null;
          this.nextBtn = null;
        }
      }
      
      document.body.style.overflow = '';
    }


    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || [];
      this.currentIndex = this.groupItems.indexOf(this);
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex - 1;
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return;

      let targetIndex = this.currentIndex + 1;
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0;
      }

      const targetLightbox = this.groupItems[targetIndex];
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox);
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox();
      
      // Open target lightbox immediately
      targetLightbox.openLightbox();
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group);
        
        this.groupItems.forEach(lightbox => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img');
          images.forEach(img => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img);
          });
        });
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map(src => src.trim().split(' ')[0]);
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src;
        let largestSize = 0;
        
        srcsetUrls.forEach(url => {
          const size = this.extractImageSize(url);
          if (size > largestSize) {
            largestSize = size;
            largestUrl = url;
          }
        });
        
        this.prefetchImage(largestUrl);
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src);
        this.prefetchImage(largestUrl);
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url);
        
        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0;
        }
        
        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_');
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/);
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0;
          }
        }
      } catch (e) {
        // URL parsing failed
      }
      
      return 0;
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl);
        
        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400');
          return url.toString();
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_');
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg';
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension;
            url.pathname = newPath;
            return url.toString();
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }
      
      return originalUrl;
    }

    prefetchImage(url) {
      const prefetchImg = new Image();
      prefetchImg.src = url;
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open');
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group);
        if (groupItems) {
          const index = groupItems.indexOf(this);
          if (index > -1) {
            groupItems.splice(index, 1);
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group);
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super();
      this.cache = new Map(); // Cache for pre-fetched content
      this.activeRequests = new Map(); // Track active fetch requests
      this.loadingTimeout = null; // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document;
      
      this.addEventListener('change', (event) => this.onVariantChange(event));
      this.addEventListener('mouseover', (event) => this.onMouseOver(event));
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading');
      }, 200);
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
        this.loadingTimeout = null;
      }
      
      // Remove loading animation
      this.classList.remove('product-hot-reload--loading');
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form');
      const sectionId = this.dataset.sectionId;
      
      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId;
      
      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl;
        optionValueId = input.dataset.optionValueId;
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl;
        optionValueId = selectedOption.dataset.optionValueId;
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = [];
      
      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'));
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean);
      
      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'));
      selects.forEach(select => {
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId);
        }
      });

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name;
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter(id => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`);
          return input && input.name !== currentOptionName;
        });
        // Add the hovered option value
        selectedOptionValues.push(optionValueId);
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';
      return `${newProductUrl}?section_id=${sectionId}${params}`;
    }

    onMouseOver(event) {
      const label = event.target.closest('label');
      if (!label) return;

      const input = label.querySelector('input[type="radio"]');
      if (!input) return;

      // Don't pre-fetch if already selected
      if (input.checked) return;

      const requestUrl = this.buildRequestUrl(input);

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return;

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl);
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.cache.set(requestUrl, html);
          this.activeRequests.delete(requestUrl);
          return html;
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl);
          throw error;
        });

      this.activeRequests.set(requestUrl, fetchPromise);
      return fetchPromise;
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return;

      const optionValueElement = event.target;
      const requestUrl = this.buildRequestUrl(optionValueElement);
      const oldProductUrl = this.dataset.productUrl;
      
      // Get new product URL from the input or selected option
      let newProductUrl;
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl;
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex];
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl;
      } else {
        newProductUrl = oldProductUrl;
      }

      // Start loading state immediately on change event
      this.showLoadingState();

      let html;

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl);
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl);
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl);
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id);
      } catch (error) {
        console.error('Error updating product content:', error);
      } finally {
        // Always hide loading state
        this.hideLoadingState();
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id);
      
      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML;
          this.dataset.productUrl = updatedHtml.dataset.productUrl;
          this.dataset.variantId = updatedHtml.dataset.variantId;
        });

        // Wait for the transition to complete
        await transition.finished;
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML;
        this.dataset.productUrl = updatedHtml.dataset.productUrl;
        this.dataset.variantId = updatedHtml.dataset.variantId;
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin);

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href);
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value);
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId);

      // Push new state to browser history
      window.history.pushState({}, '', url.toString());

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus();
    }
  }

  customElements.define('product-hot-reload', ProductHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.gift-recipient"] && !Shopify.designMode) return;
  try {
    class GiftRecipientForm extends HTMLElement {
    constructor() {
      super()
      this.checkboxInput = this.querySelector('.gift-recipient-form__checkbox input[type="checkbox"]')
      this.emailInput = this.querySelector('.gift-recipient-form__email')
      this.nameInput = this.querySelector('.gift-recipient-form__name')
      this.messageInput = this.querySelector('.gift-recipient-form__message')
      this.dateInput = this.querySelector('.gift-recipient-form__date')
      this.addEventListener('change', () => this.onChange())
      this.recipientFields = this.querySelector('.recipient-fields')

      this.checkboxInput.addEventListener('change', () => {
        event.stopPropagation()
        this.recipientFields.style.display = this.checkboxInput.checked ? 'block' : 'none'
      })
    }

    connectedCallback() {
      this.abortController = new AbortController()

      document.addEventListener('product-form:submit:error', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.displayErrorMessage(event.detail.errorMessage)
        }
      }, { signal: this.abortController.signal })

      document.addEventListener('product-form:submit:success', (event) => {
        if (event.target.form.id === this.dataset.formId) {
          this.clearInputFields()
          this.clearErrorMessage()
        }
      }, { signal: this.abortController.signal })
    }

    disconnectedCallback() {
      this.abortController.abort()
    }

    onChange() {
      if (!this.checkboxInput.checked) {
        this.clearInputFields()
        this.clearErrorMessage()
      }
    }

    clearInputFields() {
      for (const element of this.querySelectorAll('input')) {
        element.value = ''
      }
    }

    displayErrorMessage(body) {
      this.clearErrorMessage()
      if (body) {
        return Object.entries(body).forEach(([key, value]) => {
          const inputElement = this[`${key}Input`]
          if (!inputElement) {
            return
          }

          inputElement.setAttribute('aria-invalid', true)
        })
      }
    }

    clearErrorMessage() {
      for (const inputElement of this.querySelectorAll('input')) {
        inputElement.setAttribute('aria-invalid', false)
        inputElement.removeAttribute('aria-describedby')
      }
    }
  }

  customElements.define('gift-recipient-form', GiftRecipientForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section.flex-pdp.media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGalleryElement extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.media-gallery__slide');
      this.thumbs = this.querySelectorAll('.media-gallery__thumb');
      this.prevBtn = this.querySelector('.media-gallery__nav--prev');
      this.nextBtn = this.querySelector('.media-gallery__nav--next');
      this.mainContainer = this.querySelector('.media-gallery__main');
      this.currentIndex = 0;
      this.isAnimating = false;
      this.isNaturalAspectRatio = this.mainContainer?.getAttribute('data-aspect-ratio') === 'initial';

      // Touch/swipe handling
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchEndX = 0;
      this.touchEndY = 0;
      this.minSwipeDistance = 50;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Adjust container height for natural aspect ratio
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight(true); // Disable transition for initial setup

        // Set up resize observer for images that might load asynchronously
        this.setupResizeObserver();
      }

      // Add click handlers to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const direction = index > this.currentIndex ? 'next' : 'prev';
          this.goToSlide(index, direction);
        });
      });

      // Add click handlers to navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.previousSlide();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.nextSlide();
        });
      }

      // Add keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.previousSlide();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      });

      // Make the gallery focusable for keyboard navigation
      this.setAttribute('tabindex', '0');

      // Add touch/swipe handlers
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: true });

      // Ensure only the initial active slide can play
      this.pauseNonActiveSlides();
      this.autoplayActiveSlideIfEligible();
    }

    goToSlide(index, direction = 'next') {
      if (index < 0 || index >= this.slides.length) return;
      if (index === this.currentIndex) return;
      if (this.isAnimating) return;

      const currentSlide = this.slides[this.currentIndex];
      const targetSlide = this.slides[index];

      // Before animating, pause non-target slides
      this.pauseAllMediaExceptInSlide(targetSlide);

      // Reset all slides
      this.resetSlides();

      // Position slides for animation
      this.positionSlidesForAnimation(currentSlide, targetSlide, direction);

      // Update UI state
      this.updateThumbnails(index);
      this.currentIndex = index;

      // Start animation after positioning is applied
      this.animateSlides(currentSlide, targetSlide, direction);

      // Adjust container height for natural aspect ratio after slide change
      if (this.isNaturalAspectRatio) {
        setTimeout(() => {
          this.adjustContainerHeight();
        }, 50); // Small delay to ensure slide is positioned
      }
    }

    resetSlides() {
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--prev', 'media-gallery__slide--next');
      });
    }

    positionSlidesForAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class from all slides during positioning
      this.slides.forEach(slide => {
        slide.classList.remove('media-gallery__slide--is-animating');
      });

      if (direction === 'next') {
        // Next: target and others on right, current stays in center
        targetSlide.style.transform = 'translateX(100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(100%)';
          }
        });
      } else {
        // Previous: target and others on left, current stays in center
        targetSlide.style.transform = 'translateX(-100%)';
        this.slides.forEach(slide => {
          if (slide !== currentSlide && slide !== targetSlide) {
            slide.style.transform = 'translateX(-100%)';
          }
        });
      }
    }

    updateThumbnails(activeIndex) {
      this.thumbs[this.currentIndex].classList.remove('media-gallery__thumb--active');
      this.thumbs[activeIndex].classList.add('media-gallery__thumb--active');
    }

    adjustContainerHeight(disableTransition = false) {
      if (!this.isNaturalAspectRatio || !this.mainContainer) return;

      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      // Disable transition if requested (for initial setup)
      if (disableTransition) {
        this.mainContainer.classList.add('media-gallery__main--no-transition');
      }

      // Find the image in the active slide
      const img = activeSlide.querySelector('img');
      if (!img) return;

      // Get the image's natural dimensions
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;

      if (imgWidth && imgHeight) {
        // Calculate the aspect ratio
        const aspectRatio = imgWidth / imgHeight;

        // Get the container width
        const containerWidth = this.mainContainer.offsetWidth;

        // Calculate the height based on the aspect ratio
        const calculatedHeight = containerWidth / aspectRatio;

        // Set the container height
        this.mainContainer.style.height = calculatedHeight + 'px';
      } else {
        // Fallback: temporarily make the slide visible to measure its height
        const originalOpacity = activeSlide.style.opacity;
        const originalTransform = activeSlide.style.transform;
        activeSlide.style.opacity = '1';
        activeSlide.style.transform = 'translateX(0)';
        activeSlide.style.position = 'relative';
        activeSlide.style.visibility = 'hidden';

        // Get the natural height of the slide content
        const slideHeight = activeSlide.offsetHeight;

        // Restore original styles
        activeSlide.style.opacity = originalOpacity;
        activeSlide.style.transform = originalTransform;
        activeSlide.style.position = '';
        activeSlide.style.visibility = '';

        // Set the container height to match the slide height
        this.mainContainer.style.height = slideHeight + 'px';
      }

      // Re-enable transition after a brief delay
      if (disableTransition) {
        setTimeout(() => {
          this.mainContainer.classList.remove('media-gallery__main--no-transition');
        }, 10);
      }
    }

    setupResizeObserver() {
      if (!this.isNaturalAspectRatio || !window.ResizeObserver) return;

      this.resizeObserver = new ResizeObserver(() => {
        this.adjustContainerHeight();
      });

      // Observe all images in the slides
      this.slides.forEach(slide => {
        const images = slide.querySelectorAll('img');
        images.forEach(img => {
          this.resizeObserver.observe(img);

          // Also listen for load events to recalculate when image loads
          img.addEventListener('load', () => {
            if (slide.classList.contains('media-gallery__slide--active')) {
              this.adjustContainerHeight();
            }
          });
        });
      });
    }

    animateSlides(currentSlide, targetSlide, direction) {
      // Set animation flag
      this.isAnimating = true;

      // Frame 1: Initial positions are already set (no animation class)

      // Frame 2: Add animation class
      requestAnimationFrame(() => {
        currentSlide.classList.add('media-gallery__slide--is-animating');
        targetSlide.classList.add('media-gallery__slide--is-animating');

        // Frame 3: Trigger animation
        requestAnimationFrame(() => {
          // Animate current slide out
          if (direction === 'next') {
            currentSlide.style.transform = 'translateX(-100%)';
          } else {
            currentSlide.style.transform = 'translateX(100%)';
          }

          // Animate target slide in
          targetSlide.style.transform = 'translateX(0)';
          targetSlide.classList.add('media-gallery__slide--active');

          // Clean up after animation
          this.waitForTransition(currentSlide).then(() => {
            this.positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction);
            this.scrollActiveThumbnailIntoView();
            // Hydrate and autoplay current slide media if eligible and pause others
            this.pauseNonActiveSlides();
            this.autoplayActiveSlideIfEligible();
            // Clear animation flag
            this.isAnimating = false;
          });
        });
      });
    }

    positionCurrentSlideAfterAnimation(currentSlide, targetSlide, direction) {
      // Remove animation class and active class from current slide
      currentSlide.classList.remove('media-gallery__slide--is-animating', 'media-gallery__slide--active');
      targetSlide.classList.remove('media-gallery__slide--is-animating');

      if (direction === 'next') {
        currentSlide.style.transform = 'translateX(100%)';
      } else {
        currentSlide.style.transform = 'translateX(-100%)';
      }

      // Adjust container height for natural aspect ratio after animation
      if (this.isNaturalAspectRatio) {
        this.adjustContainerHeight();
      }
    }

    scrollActiveThumbnailIntoView() {
      this.thumbs[this.currentIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex, 'next');
    }

    previousSlide() {
      const prevIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex, 'prev');
    }

    waitForTransition(element) {
      return new Promise((resolve) => {
        const handleTransitionEnd = (e) => {
          if (e.target === element) {
            element.removeEventListener('transitionend', handleTransitionEnd);
            resolve();
          }
        };
        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleTouchStart(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchStartX = touch.clientX;
      this.touchStartY = touch.clientY;
    }

    handleTouchMove(e) {
      if (this.isAnimating) return;

      const touch = e.touches[0];
      this.touchEndX = touch.clientX;
      this.touchEndY = touch.clientY;
    }

    handleTouchEnd(e) {
      if (this.isAnimating) return;

      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const absDeltaX = Math.abs(deltaX);
      const absDeltaY = Math.abs(deltaY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (absDeltaX > absDeltaY && absDeltaX > this.minSwipeDistance) {
        if (deltaX > 0) {
          // Swipe right - go to previous slide
          this.previousSlide();
        } else {
          // Swipe left - go to next slide
          this.nextSlide();
        }
      }
    }

    // Utilities for media control
    pauseAllMediaExceptInSlide(slide) {
      const allowed = new Set(slide ? Array.from(slide.querySelectorAll('video-media, model-media')) : []);
      this.querySelectorAll('video-media[playing], model-media[playing]').forEach((el) => {
        if (!allowed.has(el)) {
          el.pause();
        }
      });
    }

    pauseNonActiveSlides() {
      this.slides.forEach((slide, index) => {
        if (index !== this.currentIndex) {
          slide.querySelectorAll('video-media[playing], model-media[playing]').forEach((element) => element.pause());
        }
      });
    }

    autoplayActiveSlideIfEligible() {
      const activeSlide = this.slides[this.currentIndex];
      if (!activeSlide) return;

      const mediaEls = activeSlide.querySelectorAll('video-media, model-media');
      mediaEls.forEach((element) => {
        if (!element.hasAttribute('autoplay')) return;
        if (element.hasAttribute('playing')) return;
        // If already loaded, try immediately; else wait for 'loaded' attribute
        if (element.hasAttribute('loaded')) {
          element.play();
        } else {
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'loaded' && element.hasAttribute('loaded')) {
                observer.disconnect();
                element.play();
                break;
              }
            }
          });

          observer.observe(element, { attributes: true, attributeFilter: ['loaded'] });
        }
      });
    }
  }

  // Define the custom element
  customElements.define('media-gallery', MediaGalleryElement);
  } catch(e) { console.error(e); }
})();

})();
